<template>
    <div
        class="card job-card col-sm-12"
        :class="{'past-job': timeSlot.end < now, 'attended': timeSlot.job.status === 'attended', 'call-out': timeSlot.job.is_call_out, complete: isComplete}"
    >
        <div class="card-body">
            <div class="card-content">
                <router-link :to="{ name: 'engineer.jobs.show', params: { id: timeSlot.job.id } }">
                    <h5>
                        <span
                            v-if="timeSlot.job.is_call_out"
                            class="job-call-out-title"
                        >Call out: </span>
                        {{ timeSlot.job.name }}
                    </h5>
                </router-link>
                <ul class="job-items">
                    <li><strong>Status:</strong> {{ timeSlot.job.status | capitalize }}</li>
                    <li><strong>Customer:</strong> {{ timeSlot.job.customer.company_name }}</li>
                    <li><strong>Site:</strong> {{ timeSlot.job.site.name }}</li>
                    <li v-if="timeSlot.job.site && timeSlot.job.site.address">
                        <strong>Address:</strong> {{ timeSlot.job.site.address.address_line_1 }}, {{ timeSlot.job.site.address.postcode }}
                    </li>
                    <li
                        v-if="updatedAt"
                        class="job-updated-at"
                    >
                        <strong>Last Updated:</strong> {{ updatedAt }}
                    </li>
                    <li>
                        <a
                            href="#"
                            class="job-inventory-link"
                            @click.stop.prevent="toggleInventory"
                        >
                            <span v-if="!showInventory">Show Service Inventory</span>
                            <span v-if="showInventory">Hide Service Inventory</span>
                        </a>
                    </li>
                    <li>
                        <a
                            href="#"
                            class="job-inventory-link"
                            @click.stop.prevent="toggleDescription"
                        >
                            <span v-if="!showDescription">Show Job Description</span>
                            <span v-if="showDescription">Hide Job Description</span>
                        </a>
                    </li>
                    <li v-if="timeSlot.job && timeSlot.job.first_name">
                        <strong>First name:</strong> {{ timeSlot.job.first_name }}
                    </li>
                    <li v-if="timeSlot.job && timeSlot.job.last_name">
                        <strong>Last name:</strong> {{ timeSlot.job.last_name }}
                    </li>
                    <li
                        class="job-important"
                        v-if="importantInfo"
                    >
                        <strong><i class="fas fa-exclamation-triangle" /> Important Info:</strong>
                        <div v-html="importantInfo" />
                    </li>
                    <li
                        class="job-card__description"
                        v-show="showDescription"
                    >
                        <strong>Description:</strong> <span v-html="description" />
                    </li>
                </ul>
            </div>
            <router-link
                class="card-link"
                :to="{ name: 'engineer.jobs.show', params: { id: timeSlot.job.id } }"
            >
                <i class="fas fa-play" />
            </router-link>
        </div>
        <job-inventory
            v-if="showInventory"
            :job="timeSlot.job"
        />
    </div>
</template>

<script>
import JobInventory from "./JobInventoryComponent";

export default {
    components: {
        JobInventory
    },
    props: {
        timeSlot: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            showInventory: false,
            showDescription: false,
        };
    },

    computed: {
        now: () => window.moment(),

        isTimeslotOverDays() {
            const days = this.timeSlot.start.diff(this.timeSlot.end, "days");
            return days !== 0;
        },

        updatedAt() {
            if (!this.timeSlot || !this.timeSlot.job.updated_at) {
                return null;
            }
            return window.moment(this.timeSlot.job.updated_at).fromNow();
        },

        description () {
            if (!this.timeSlot.job.description) {
                return 'No description provided';
            }

            return window.injectTelAndEmails(this.timeSlot.job.description);
        },
        importantInfo () {
            if (!this.timeSlot.job.important_info) {
                return null;
            }
            return window.injectTelAndEmails(this.timeSlot.job.important_info);
        },
        isComplete () {
            return this.timeSlot.job.status === 'attended' && !this.timeSlot.job.handover_form_required;
        }
    },

    methods: {
        toggleInventory() {
            this.showInventory = !this.showInventory;
        },
        toggleDescription() {
            this.showDescription = !this.showDescription;
        }
    }
};
</script>

<style lang="scss" scope>
.attended {
    opacity: 0.6;

    .card-time {
        color: #60cf81 !important;
    }
}

.complete {
    border: 1px solid #60cf81 !important;

    .card-link {
        background: #60cf81 !important;
    }
}

.call-out {
    border-color: #0079ff;

    .card-time,
    .job-call-out-title {
        color: #0079ff !important;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/engineer/JobListItemComponent.vue